
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiListDataService} from './api.list-data.service';

@Injectable({
  providedIn: 'root'
})
export class ApiDeliveryPointSubrecipientsService extends ApiListDataService<any, any> {
  constructor(http: HttpClient) {
    super(http, '/Organization/');
  }

  public getByName(name: string): Observable<any[]> {
    let params = new HttpParams();
    if (name) {
      params = params.set('name', name); 
    }

    return this.http.get<any[]>('v1/Organization/DeliveryPointSubrecipientsByName', { params });
  }
}
